import { differenceInCalendarDays, format, startOfDay } from "date-fns";
import { ptBR } from "date-fns/locale";
import { STATUS_META } from "@/components/prosthesis/prosthesis-meta";
import type { ClinicOutgoingOrder } from "@/lib/dashboard-lab";
import { cn } from "@/lib/cn";
import { ROTULO_DO_STATUS, entregaDe, servicosDe } from "./resumo-de-pedidos";

function quandoDe(entrega: Date): { texto: string; classe: string } {
  const dias = differenceInCalendarDays(startOfDay(entrega), startOfDay(new Date()));
  if (dias < 0) return { texto: dias === -1 ? "há 1 dia" : `há ${-dias} dias`, classe: "text-red-600 dark:text-red-400" };
  if (dias === 0) return { texto: "hoje", classe: "text-brand-700 dark:text-primary" };
  return { texto: dias === 1 ? "amanhã" : `em ${dias} dias`, classe: "text-zinc-600 dark:text-muted-foreground" };
}

/** Pedido do resumo em duas linhas: quem e quando em cima, o trabalho e de onde embaixo. */
export function CartaoDoResumoDaClinica({ order: o, comDentista, onClick }: { order: ClinicOutgoingOrder; comDentista: boolean; onClick: () => void }) {
  const meta = STATUS_META[o.status];
  const entrega = entregaDe(o);
  const quando = quandoDe(entrega);
  const servicos = servicosDe(o);
  const detalhe = [servicos, o.labName ?? "Laboratório", comDentista ? o.dentistName : null].filter(Boolean).join(" · ");
  return (
    <button
      type="button"
      onClick={onClick}
      title={detalhe}
      className="block w-full rounded-lg border border-zinc-200 bg-white px-3 py-2 text-left transition-all hover:border-zinc-300 hover:shadow-sm dark:border-border dark:bg-card"
    >
      <div className="flex items-center gap-2">
        <p className="min-w-0 truncate text-sm font-medium text-zinc-800 dark:text-foreground">{o.patientName}</p>
        {o.numero != null && <span className="shrink-0 text-[11px] tabular-nums text-zinc-400 dark:text-muted-foreground">#{o.numero}</span>}
        <span className="shrink-0 rounded-full px-1.5 py-px text-[10px] font-semibold" style={{ backgroundColor: meta.bg, color: meta.color }}>
          {ROTULO_DO_STATUS[o.status] ?? meta.label}
        </span>
        {o.status !== "RECUSADO" && <span className={cn("ml-auto shrink-0 text-xs font-semibold", quando.classe)}>{quando.texto}</span>}
      </div>
      <div className="mt-0.5 flex items-center gap-2 text-xs text-zinc-500 dark:text-muted-foreground">
        <span className="min-w-0 flex-1 truncate">{detalhe}</span>
        <span className="shrink-0 tabular-nums">
          {o.deadline ? "Entrega" : "Prazo"} {format(entrega, "dd/MM", { locale: ptBR })}
        </span>
      </div>
    </button>
  );
}
